module.exports = __webpack_public_path__ + "static/media/ID4GTX.6829e779.jpg";